import { useModal } from "../../../../utils/ModalContext";
import { useEffect, useState } from "react";
import { FaDiscord, FaRegArrowAltCircleUp, FaArrowUp, FaTelegram, FaWallet } from "react-icons/fa";
import { MdNotes } from "react-icons/md";
import Button from "../../../../common/button";
import NavWrapper from "./Header.style";
import MobileMenu from "../mobileMenu/MobileMenu";
import logo from "../../../../assets/images/logo/logo.png";
import {  useNavigate } from "react-router-dom";
const Header = () => {
  const { walletModalHandle } = useModal();
  const [isMobileMenu, setMobileMenu] = useState(false);
  const handleMobileMenu = () => {
    setMobileMenu(!isMobileMenu);
  };

  const navigate = useNavigate();
  useEffect(() => {
    const header = document.getElementById("navbar");
    const handleScroll = window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });

    return () => {
      window.removeEventListener("sticky", handleScroll);
    };
  }, []);
  return (
    <NavWrapper className="bithu_header" id="navbar">
      <div className="container">
        {/* Main Menu Start */}
        <div className="bithu_menu_sect">
          <div className="bithu_menu_left_sect">
            <div className="logo">
              <a href="/">
                <img src={logo} alt="AlphaOctopus nft logo" style={{height:75}} />
              </a>
            </div>
          </div>
          <div className="bithu_menu_right_sect bithu_v1_menu_right_sect">
            <div className="bithu_menu_list">
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#roadmap">Roadmap</a>
                </li>
                <li>
                  <a href="#team">Team</a>
                </li>
                <li>
                  <a href="#faq">FAQ</a>
                </li>
                <li>
                  <a href="https://www.safetin.com/audit/alpha-octopus" target={"_blank"}>AUDIT REPORT</a>
                   <span style={{
                        color: "#f3d807",
                        fontSize: "12px",
                        fontWeight: 900,
                        position: "absolute",
                        top: "0",
                  }}>New</span>
                </li>
                {/* <li>
                  <a href="">Explore</a>
                </li> */}
                {/* <li className="submenu">
                  <a href="# ">Pages +</a>
                  <div className="sub_menu_sect">
                    <ul className="sub_menu_list">
                      <li>
                        <a href="/home-one">Home One</a>
                      </li>
                      <li>
                        <a href="/">Home Two</a>
                      </li>
                      <li>
                        <a href="/home-three">Home Three</a>
                      </li>
                      <li>
                        <a href="/blogs">Latest Blog</a>
                      </li>
                      <li>
                        <a href="/post">Blog Details</a>
                      </li>
                    </ul>
                  </div>
                </li> */}
              </ul>
            </div>
            <div className="bithu_menu_btns">
              <button className="menu_btn" onClick={() => handleMobileMenu()}>
                <MdNotes />
              </button>
              <Button lg variant="outline" className="join_btn">
                <a href="https://discord.gg/XEeghFerwh" target="_blank" rel="noopener noreferrer"
                style={{
                  color: "#fff",
                  textTransform: "uppercase",
                  fontFamily: "Bakbak One",
                  fontWeight: 400,
                  fontSize: "16px"
                }}
                >
                <FaDiscord /> Join
                 </a>
              </Button>
            
              <Button
                md
                variant="hovered"
                className="connect_btn"
                onClick={() => navigate('/mint')}
              >
                
                <FaWallet /> Mint Now

              </Button>
            </div>
          </div>
        </div>
        {/* <!-- Main Menu END --> */}
        {isMobileMenu && <MobileMenu mobileMenuhandle={handleMobileMenu} />}
      </div>
    </NavWrapper>
  );
};

export default Header;
